import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Default title - will be overridden by SEOHead per page/language
document.title = 'ELVORA Consulting';
render(<App data-id="element-287" />, document.getElementById('root'));